export const GITLAB_ISSUES_STATE = {
  OPENED: "opened",
};

export const ALL_USERS_VALUE = "all";
